exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#page-title a{text-decoration:none;color:inherit}#page-title .sub-title{font-weight:300}#page-title i{display:inline-block}#page-title .sub-nav{top:48px;left:-16px}", ""]);

